module.exports = require("@projectstorm/react-diagrams-routing");